import { action, Action } from 'typesafe-actions'

import {
  DadosPessoaisTypes,
  PostDadosPessoaisPayload,
  GetDadosPessoaisPayload,
  RejectedBankAccount,
} from './types'

export const setUserNameDadosPessoais = (payload: string): Action =>
  action(DadosPessoaisTypes.SET_USER_NAME_DADOS_PESSOAIS, payload)

export const setCpfDadosPessoais = (payload: string): Action =>
  action(DadosPessoaisTypes.SET_CPF_DADOS_PESSOAIS, payload)

export const setDataNascimento = (payload: string): Action =>
  action(DadosPessoaisTypes.SET_DATA_NASCIMENTO, payload)

export const setContaDadosPessoais = (payload: string): Action =>
  action(DadosPessoaisTypes.SET_CONTA_DADOS_PESSOAIS, payload)

export const postDadosPessoaisRequest = (payload: PostDadosPessoaisPayload): Action =>
  action(DadosPessoaisTypes.POST_DADOS_PESSOAIS_REQUEST, payload)

export const getDadosPessoaisRequest = (payload: GetDadosPessoaisPayload): Action =>
  action(DadosPessoaisTypes.GET_DADOS_PESSOAIS_REQUEST, payload)

export const getDadosPessoaisSuccess = (): Action =>
  action(DadosPessoaisTypes.GET_DADOS_PESSOAIS_SUCCESS)

export const getDadosPessoaisError = (): Action =>
  action(DadosPessoaisTypes.GET_DADOS_PESSOAIS_ERROR)

export const resetDadosPessoaisLoading = (): Action =>
  action(DadosPessoaisTypes.RESET_DADOS_PESSOAIS_LOADING)

export const setHasEndereco = (hasEndereco: boolean): Action =>
  action(DadosPessoaisTypes.SET_HAS_ENDERECO, hasEndereco)

export const setHasDadosBancarios = (hasDadosBancarios: boolean): Action =>
  action(DadosPessoaisTypes.SET_HAS_DADOS_BANCARIOS, hasDadosBancarios)

export const setIsValidModalityAccount = (payload: boolean | null): Action =>
  action(DadosPessoaisTypes.SET_IS_VALID_MODALITY_ACCOUNT, payload)

export const setPostDadosPessoaisLoading = (payload: boolean): Action =>
  action(DadosPessoaisTypes.SET_POST_DADOS_PESSOAIS_LOADING, payload)

export const setBankAccountCorrectionMode = (payload: boolean): Action =>
  action(DadosPessoaisTypes.SET_BANK_ACCOUNT_CORRECTION_MODE, payload)

export const setRejectedBankAccount = (payload: RejectedBankAccount): Action =>
  action(DadosPessoaisTypes.SET_REJECTED_BANK_ACCOUNT, payload)

export const clearBankAccountCorrection = (): Action =>
  action(DadosPessoaisTypes.CLEAR_BANK_ACCOUNT_CORRECTION)
